<template lang="pug">
.w-100
    .tabela(v-if='tableData.length > 0')
        el-table.w-100.my-3.rolagem-tabela-laudo(
            ref='tableLaudos',
            :data='tableData',
            :row-key='getRowKey',
            @sort-change='sortChangeRequest',
            @selection-change='alterarLaudosSelecionados',
            stripe,
            height='1000'
        )
            el-table-column(
                align='center',
                type='selection',
                :reserve-selection='true',
                :selectable='canSelectRow'
            )
            el-table-column(
                v-if='showAnalystColumns',
                width='50',
                prop='id',
                label='ID',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.id || '--' }}
            el-table-column(
                prop='codigo',
                :label='$t("laudos.gridColunaHash")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(:title='scope.row.codigo') {{ scope.row.codigo || '--' }}
            el-table-column(
                prop='informacaoLaudo.nomeTerritorio',
                :label='$t("laudos.territorio")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(
                        v-if='scope.row.informacaoLaudo && scope.row.informacaoLaudo.nomeTerritorio != null',
                        :title='scope.row.informacaoLaudo.nomeTerritorio'
                    ) {{ scope.row.informacaoLaudo.nomeTerritorio }}
                    span(v-else) --
            el-table-column(
                prop='informacaoLaudo.car.codigo',
                :label='$t("laudos.car")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(
                        :title='scope.row.informacaoLaudo.car.codigo'
                    ) {{ scope.row.informacaoLaudo.car.codigo }}
            el-table-column(
                prop='dataCadastroFormatado',
                :label='$t("laudos.dataSolicitacao")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row.dataCadastroFormatado || '--' }}
            el-table-column(
                prop='dataFinalizacaoFormatado',
                :label='$t("laudos.dataEntrega")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='situacao',
                width='200px',
                :label='$t("laudos.situacao")',
                sortable
            )
                .template(slot-scope='scope')
                    LabelSituacao(
                        :tipo='tipoLabel',
                        :codigo='scope.row.situacao.codigo'
                    )
            el-table-column(
                prop='elegivelRenovabio',
                :label='$t("laudos.renovabioNome")',
                sortable
            )
                .template(slot-scope='scope')
                    LabelRenovabio(
                        :tipo='tipoLabel',
                        :elegivel='scope.row.elegivelRenovabio'
                    )

            el-table-column(
                v-if='showAnalystColumns',
                prop='usuarioAnaliseNome',
                :label='$t("laudos.analistaResponsavel")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(:title='scope.row.usuarioAnaliseNome') {{ scope.row.usuarioAnaliseNome || '--' }}
            el-table-column(
                v-if='showAnalystColumns',
                prop='usuarioSolicitacaoNome',
                :label='$t("mensagens.comuns.solicitante")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(:title='scope.row.usuarioSolicitacaoNome') {{ scope.row.usuarioSolicitacaoNome || '--' }}
            el-table-column(
                v-if='showAnalystColumns',
                prop='nomeEmpresa',
                :label='$t("laudos.empresa")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(:title='scope.row.nomeEmpresa') {{ scope.row.nomeEmpresa || '--' }}

            el-table-column(
                :label='$t("mensagens.comuns.acoes")',
                align='left'
            )
                .template.d-flex.justify-content-left(slot-scope='scope')
                    el-dropdown.action-button(
                        trigger='click',
                        :disabled='!hasDropdownItems(scope)'
                    )
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                v-if='scope.row.situacao.codigo === "PROCESSADO"',
                                icon='el-icon-download',
                                @click.native='downloadLaudo(scope.row)'
                            ) {{ $t('laudos.baixarLaudo') }}
                            el-dropdown-item(
                                v-if='scope.row.situacao.codigo === "NA_FILA" && !showAnalystColumns',
                                icon='el-icon-circle-close',
                                @click.native='showModalCancelarLaudo(scope.row)'
                            ) {{ $t('laudos.cancelarLaudo') }}
                            el-dropdown-item(
                                v-if='scope?.row?.situacao?.codigo !== "CANCELADO" && showAnalystColumns',
                                icon='el-icon-download',
                                @click.native='baixarDados(scope.row.id)'
                            ) {{ $t('laudos.baixarDados') }}
                            el-dropdown-item(
                                v-if='scope?.row?.situacao?.codigo !== "CANCELADO" && showAnalystColumns',
                                icon='el-icon-upload',
                                @click.native='abreModalInserirResultado(scope.row)',
                                :disabled='scope.row.situacao.codigo === "PROCESSADO"'
                            ) {{ $t('laudos.inserirResultado') }}
                            el-dropdown-item(
                                v-if='scope?.row?.situacao?.codigo === "CANCELADO" && showAnalystColumns',
                                icon='el-icon-minus'
                            ) {{ $t('laudos.nenhumaAcao') }}

    EmptyResultLaudo(
        v-else,
        :semLaudoSelecionado='false',
        :p1='$t("mensagens.comuns.semDados")',
        :p2='$t("laudos.naoConseguimosLocalizarNenhumLaudo")'
    )
</template>

<script>
import LaudosService from '@/modules/laudos/services/LaudosService';
import UtilsService from '@/modules/laudos/services/UtilsService';
import AuthService from '@/services/AuthService';
import LabelTipo from '@/modules/laudos/constants/LabelTipo';
import LabelSituacao from '@/modules/laudos/components/LabelLaudoSituacao.vue';
import LabelRenovabio from '@/modules/laudos/components/LabelLaudoRenovabio.vue';
import EventBus from '@/utils/eventBus';
import EmptyResultLaudo from '@/modules/laudos/components/EmptyResultLaudo.vue';

export default {
    name: 'LaudoListagemAnalista',
    components: {
        EmptyResultLaudo,
        LabelSituacao,
        LabelRenovabio
    },
    props: {
        tableData: {
            type: Array,
            required: true
        },
        showAnalystColumns: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            idKeycloak: '',
            tipoLabel: LabelTipo.BARRA
        };
    },
    created() {
        AuthService.isLogged().then(({ data }) => {
            this.idKeycloak = data.idKeyCloack;
        });
    },
    mounted() {
        EventBus.$off('laudos:limpar-selecao');
        EventBus.$on('laudos:limpar-selecao', () => {
            this.$refs.tableLaudos.clearSelection();
        });

        EventBus.$off('laudos:marcar-todos');
        EventBus.$on('laudos:marcar-todos', () => {
            this.$refs.tableLaudos.toggleAllSelection();
        });
    },
    methods: {
        hasDropdownItems(scope) {
            const situacaoCodigo = scope.row?.situacao?.codigo;
            const isAnalyst = this.showAnalystColumns;

            return (
                situacaoCodigo === 'PROCESSADO' ||
                situacaoCodigo === 'NA_FILA' ||
                (isAnalyst && situacaoCodigo !== 'CANCELADO')
            );
        },
        sortChangeRequest(column) {
            let prop = column.prop;
            if (prop.includes('.')) {
                prop = prop.split('.')[1];
            }

            if (prop === 'dataCadastroFormatado') {
                prop = 'dataCadastro';
            }
            if (prop === 'dataFinalizacaoFormatado') {
                prop = 'dataFinalizacao';
            }

            let params = {
                order: null,
                column: prop
            };

            if (column.order === 'ascending') {
                params.order = 'ASC';
            } else if (column.order === 'descending') {
                params.order = 'DESC';
            }

            this.$emit('handleSort', params);
        },
        downloadLaudo(laudo) {
            LaudosService.downloadLaudo(laudo.id)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('laudos.downloadRealizadoComSucesso')
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('laudos.erro.erroAoRealizarDownload')
                    });
                });
        },
        showModalCancelarLaudo(row) {
            this.$store.dispatch('processarEventoGoogleAnalytics', {
                eventLabel: 'VISUALIZAR_MODAL_CANCELAMENTO_LAUDOS',
                pageTitle: 'VISUALIZAR_MODAL_CANCELAMENTO_LAUDOS',
                routeName: this.$route?.name,
                routePath: this.$route?.path
            });
            this.$emit('handleModalCancelamento', row.id);
        },
        getRowKey(row) {
            return row.id;
        },
        canSelectRow(row, index) {
            return row.situacao.codigo === 'PROCESSADO';
        },
        alterarLaudosSelecionados(laudosSelecionados) {
            EventBus.$emit(
                'laudos:setar-lista-laudos-download-em-lote',
                laudosSelecionados
            );
            if (laudosSelecionados.length === 0) {
                EventBus.$emit(
                    'laudos:setar-lista-laudos-download-em-lote',
                    []
                );
            }
            EventBus.$emit('laudos:resetar-selecionar-todos');
        },
        abreModalInserirResultado(row) {
            this.$emit('handleModalInsercaoResultados', row);
        },
        async baixarDados(idLaudo) {
            try {
                await this.atualizaStatus(idLaudo);
                await UtilsService.baixarArquivo(
                    `/laudo/${idLaudo}/shape/${this.idKeycloak}`
                );
            } catch (error) {
            } finally {
                this.atualizarTabela();
            }
        },
        async atualizaStatus(idLaudo) {
            try {
                await LaudosService.atualizarStatusLaudo({
                    id: idLaudo
                });
            } catch (e) {}
        },
        atualizarTabela() {
            this.$emit('atualizarTabela');
        }
    }
};
</script>

<style lang="scss" scoped>
.tabela {
    max-height: 1400px;
}

.el-table {
    .cell {
        .truncate {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: default;
        }
    }

    .action-button {
        cursor: pointer;
    }
}

.indicador {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    display: inline-block;
    margin: 0 auto;
    max-width: 150px;
}

.situacao {
    border-radius: 50px;
    text-align: center;
}

.conforme {
    background-color: #d5f8d7;
    border: 1px solid #b0dcb3;
    color: #b0dcb3;
}

.nao-conforme {
    background-color: #f7d6da;
    border: 1px solid #e58585;
    color: #e58585;
}

.inconclusivo {
    background-color: #f7e0bf;
    border: 1px solid #e5b385;
    color: #e5b385;
}

.status {
    border-radius: 50px;
    text-align: center;
    color: var(--black);
}

.buttonCard {
    background: var(--white);
    height: 60px;
    top: -15px;
    position: relative;
    padding: 10px;
    display: flex;
    align-items: center;
}
</style>
